import { supabase } from "@/lib/supabase";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export const useProfile = () => {
    const { user, userProfile, profileChecked, checkSetupComplete } = useAuth();

    const updateProfile = async (updates) => {
        if (!user) return false;

        const { error } = await supabase
            .from("profiles")
            .update(updates)
            .eq("id", user.id);

        if (error) {
            toast.error("Failed to update profile");
            return false;
        }

        toast.success("Profile updated");

        // Refresh auth context profile state
        await checkSetupComplete(user.id);
        return true;
    };

    const deleteAccount = async () => {
        if (!user) return false;

        try {
            // This RPC function will delete the auth.user record and all associated tables via CASCADE
            const { error } = await supabase.rpc("delete_user_account");

            if (error) {
                console.error("Delete account error:", error);
                toast.error("Failed to delete account. Please contact support.");
                return false;
            }

            // Successful deletion! Sign the user out locally as well
            await supabase.auth.signOut();
            toast.success("Account permanently deleted.");
            return true;
        } catch (error) {
            console.error("Delete account error:", error);
            toast.error("An unexpected error occurred.");
            return false;
        }
    };

    return {
        profile: userProfile,
        loading: !profileChecked,
        updateProfile,
        deleteAccount,
        refetch: () => user?.id ? checkSetupComplete(user.id) : Promise.resolve(null),
    };
};
